import * as signalR from '@microsoft/signalr';

let signalRConnection: signalR.HubConnection;
let initialized = false;
let connectPromise: Promise<void> | null = null;

function startConnection(): Promise<void> {
  if (signalRConnection.state === signalR.HubConnectionState.Connected) {
    return Promise.resolve();
  }

  if (connectPromise === null) {
    connectPromise = signalRConnection.start().finally(() => {
      connectPromise = null;
    });
  }

  return connectPromise;
}

export default {
  init() {
    // Prevent duplicate connect calls on re-init.
    if (initialized) {
      return;
    }

    signalRConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_HUB_ROOT + '/streamhub')
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .build();

    initialized = true;
    startConnection().catch((e: any) =>
      console.error('[StreamingHub] initial connect failed:', e)
    );
  },
  stop() {
    initialized = false;
    connectPromise = null;
    if (signalRConnection) {
      signalRConnection.stop();
    }
  },
  async ensureConnected() {
    await startConnection();
    return signalRConnection;
  },
  getConnection() {
    return signalRConnection;
  },
};
